// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Popup, Icon } from 'semantic-ui-react'

export default class SmartComponents extends Component {
  render () {
    return (
      <Popup
        position='bottom center'
        trigger={
          <p className='mt'>
            Experimental Preview <Icon name='exclamation triangle' style={{ color: '#F4D271' }} />
          </p>
        }>
        Rendering of React Native components in a web browser is an experimental feature and may
        contain issues.
      </Popup>
    )
  }
}
